import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CloseIcon,
  IconButton,
  Row,
  Tooltip,
} from "@hightouch/htui";

import { useMediaDetailControls } from "src/components/media-detail/use-media-detail-controls";

/** Prev/next and close, from the surrounding `MediaDetailControlsProvider`. */
export function MediaDetailHeaderControls() {
  const { navigation, close } = useMediaDetailControls();

  return (
    <Row align="center" flexShrink={0}>
      {navigation.kind === "list" && (
        <>
          <Tooltip message="Previous" keyboardShortcut="←">
            <IconButton
              aria-label="Previous"
              icon={ArrowLeftIcon}
              variant="tertiary"
              isDisabled={navigation.previous.kind === "end"}
              onClick={
                navigation.previous.kind === "neighbour"
                  ? navigation.previous.go
                  : undefined
              }
            />
          </Tooltip>
          <Tooltip message="Next" keyboardShortcut="→">
            <IconButton
              aria-label="Next"
              icon={ArrowRightIcon}
              variant="tertiary"
              isDisabled={navigation.next.kind === "end"}
              onClick={
                navigation.next.kind === "neighbour"
                  ? navigation.next.go
                  : undefined
              }
            />
          </Tooltip>
        </>
      )}
      {close.kind === "in-header" && (
        <IconButton
          aria-label="Close"
          icon={CloseIcon}
          variant="tertiary"
          onClick={close.onClose}
        />
      )}
    </Row>
  );
}
